
import React from 'react';

interface ShopErrorStateProps {
  error: string;
}

export const ShopErrorState = ({ error }: ShopErrorStateProps) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold mb-4">Apparel Shop</h1>
      <p className="text-red-500">Error: {error}</p>
    </div>
  );
};

